// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__D3YY9","col":"CardReaderDesc_col__1a25P","label":"CardReaderDesc_label__3SG6I"};